import { api } from "./api";

export async function crearSubcategoriaDewey(categoria) {
  const { data } = await api.post("/subcategoriaDewey/crear", categoria);
  return data;
}
